import CommonNaviIconMenu from '../../common/component/NaviIconMenu'

class NaviIconMenu extends CommonNaviIconMenu {
  constructor (props) {
    super(props)
    this.userRole = 'companyUser'
    this.userRoleUrl = 'company_user'
    this.naviIconSetting = [
      {
        title: 'マイページ',
        url: '/company_user/',
        iconClass: 'icon-home icon-large'
      },
      {
        title: '見積書',
        url: '/company_user/estimation/real',
        iconClass: 'icon-list-alt icon-large'
      },
      {
        title: '雛型',
        url: '/company_user/estimation/template',
        iconClass: 'icon-hdd icon-large'
      },
      {
        title: '個人設定',
        url: '/company_user/personal_setting_home',
        iconClass: 'icon-user icon-large'
      },
      {
        title: 'ｱﾝｹｰﾄ回答',
        url: '/company_user/survey_answer',
        iconClass: 'icon-file icon-large'
      }
    ]
  }
}

export default NaviIconMenu



// WEBPACK FOOTER //
// ./src/company_user/components/NaviIconMenu.js